export default {"src":"/_next/static/media/FILLED_PURPLE_INFO.7dff55a3.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};